import { z } from 'zod'

/** The asset page: the open tab (history by default). */
export const assetPageSearchSchema = z.object({
  tab: z.enum(['history', 'photos']).optional().catch(undefined),
})
export type AssetPageSearch = z.infer<typeof assetPageSearchSchema>

/**
 * Asset labels: the assets by id (comma-separated, from a list's ticked rows or an asset page), or a
 * site's assets (a place and below); `print` opens the print dialog once the sheet is drawn.
 */
export const assetLabelsSearchSchema = z.object({
  ids: z
    .string()
    .regex(/^[0-9a-fA-F-]{36}(,[0-9a-fA-F-]{36})*$/)
    .optional()
    .catch(undefined),
  siteId: z.uuid().optional().catch(undefined),
  placeId: z.uuid().optional().catch(undefined),
  print: z.boolean().optional().catch(undefined),
})
export type AssetLabelsSearch = z.infer<typeof assetLabelsSearchSchema>
